// TODO: Add translations
export const errorPage = {
    errorCode: "404",
    errorDescription: "Une erreur semble s’être produite ici.",
    backToHomeScreen: "Retourner à l’accueil",
    errorExplanation1: "Diese Seite wurde verschoben oder ist nicht mehr verfügbar.",
    errorExplanation2: "Der Server konnte Ihre Anfrage leider nicht verarbeiten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut"
}
